module.exports = __webpack_public_path__ + "static/media/mais.fc86bfb8.svg";